import { DataTableNew } from '@seapoint/client/src/design-system/data-table-new';
import { getCountryCurrency } from '@seapoint/client/src/utils/get-country-currency';
import { LegalEntityCountry } from '@seapoint/server/enums';
import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { PayrollEmployee } from '../../financial-information-step/financial-information-table-column-definition';
import { recordsTableColumnDefinition } from './records-table-column-definition';

type RecordsTableProps = {
  records: PayrollEmployee[];
  selectedRowIds: string[];
  showNetPay?: boolean;
  legalEntityCountry: LegalEntityCountry;
  setSelectedRowIds: (ids: string[]) => void;
  onNetPayChange?: (employeeId: string, netPay: string) => void;
};

export const RecordsTable = ({
  records,
  selectedRowIds,
  showNetPay = false,
  legalEntityCountry,
  setSelectedRowIds,
  onNetPayChange,
}: RecordsTableProps) => {
  const table = useReactTable({
    data: records,
    columns: recordsTableColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    initialState: {
      columnVisibility: {
        netPay: showNetPay,
      },
    },
    meta: {
      rowHeight: 76,
      selectedRowIds,
      onEditEmployee: () => {},
      setSelectedRowIds,
      onNetPayChange,
      baseCurrency: getCountryCurrency(legalEntityCountry),
    },
  });

  return (
    <div className="flex flex-col gap-6">
      <DataTableNew.Table table={table} aria-label="Employee records table" className="min-w-0" />
    </div>
  );
};
